import Vue from "vue";
export const state = {
    snackbarContent: "",
    showSnackbar: false,
};

export const mutations = {
    SET_SNACKBAR(state, snackbar) {
        state.snackbarContent = snackbar.snackbarContent;
        state.showSnackbar = snackbar.showSnackbar;
    },
};

export const actions = {
    async setSnackbar({ commit }, { snackbar }) {
        if (snackbar) {
            commit("SET_SNACKBAR", snackbar);
        } else {
            commit("SET_SNACKBAR", null);
        }
    },
};

const getters = {
    snackbarContent: (state) => {
        return state.snackbarContent;
    },
    showSnackbar: (state) => {
        return state.showSnackbar;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};